export default "__VITE_ASSET__87f202d1__"